import { render } from "./MarkIcon.vue?vue&type=template&id=189546ec"
import script from "./MarkIcon.vue?vue&type=script&lang=js"
export * from "./MarkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__